// useExcelExport.js
import { useCallback } from 'react';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

/**
 * Hook personalizado para exportar datos JSON a un archivo Excel (.xlsx) y descargarlo.
 * @returns {function(Array<Object>, string, string): void} Función para exportar los datos.
 */
const useExcelExport = () => {
    
    const exportToExcel = useCallback((
        data, 
        fileName = 'data', 
        sheetName = 'Sheet1'
    ) => {
        if (!data || data.length === 0) {
            console.error('La data para exportar no puede estar vacía.');
            return;
        }

        try {
            // 1. Convertir el array de objetos JSON en una hoja de trabajo (Worksheet) de Excel
            const worksheet = XLSX.utils.json_to_sheet(data);

            // 2. Crear un nuevo libro de trabajo (Workbook)
            const workbook = XLSX.utils.book_new();
            
            // 3. Agregar la hoja de trabajo al libro de trabajo
            XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

            // 4. Escribir el libro de trabajo como un ArrayBuffer (formato Excel binario)
            const excelBuffer = XLSX.write(workbook, { 
                bookType: 'xlsx', 
                type: 'array' 
            });

            // 5. Crear un Blob a partir del ArrayBuffer
            const blob = new Blob([excelBuffer], { 
                type: 'application/octet-stream' // MIME type genérico para archivos binarios
            });

            // 6. Usar file-saver para iniciar la descarga
            saveAs(blob, `${fileName}.xlsx`);

        } catch (error) {
            console.error('Error al exportar a Excel:', error);
            // Puedes agregar aquí un manejo de estado o notificación de error
        }
    }, []);

    return { exportToExcel };
};

export default useExcelExport;